import { useLocStore } from ".";
import { CvpLocale } from "../constants/CvpLocale";
import { LocContext } from "./LocContext";

export const useCallingCode = (locale: string): number => {
  const locales = useLocales();

  if (locales[locale]) return locales[locale].callingCode;

  throw new Error("Locale not implemented: " + locale);
};

export interface LocaleObj {
  callingCode: number;
  cvpLocale: CvpLocale;
  localeNameNorwegian: string;
  label?: any;
  shortLabel?: string;
}

// https://www.nationsonline.org/oneworld/international-calling-codes.htm
export const useLocales = (): { [key: string]: LocaleObj } => {
  const L = useLocStore(LocContext.ADMIN);

  return {
    fr: {
      callingCode: 33,
      cvpLocale: CvpLocale.fr,
      localeNameNorwegian: "Fransk",
      label: L.id("52b9c5f4a9f0").loc("Fransk") + " (FR)",
      shortLabel: "fr",
    },
    en: {
      callingCode: 44,
      cvpLocale: CvpLocale.en,
      localeNameNorwegian: "Engelsk",
      label: L.id("73fe5934011c").loc("Engelsk") + " (EN)",
      shortLabel: "en",
    },
    da: {
      callingCode: 45,
      cvpLocale: CvpLocale.da,
      localeNameNorwegian: "Dansk",
      label: L.id("a0e76191b329").loc("Dansk") + " (DA)",
      shortLabel: "da",
    },
    sv: {
      callingCode: 46,
      cvpLocale: CvpLocale["sv"],
      localeNameNorwegian: "Svensk",
      label: L.id("a5bedf0afb79").loc("Svensk") + " (SV)",
      shortLabel: "sv",
    },
    nb: {
      callingCode: 47,
      cvpLocale: CvpLocale.nb,
      localeNameNorwegian: "Norsk",
      label: L.id("82ff82796d2f").loc("Norsk") + " (NB)",
      shortLabel: "nb",
    },
    pl: {
      callingCode: 48,
      cvpLocale: CvpLocale.pl,
      localeNameNorwegian: "Polsk",
      label: L.id("7954e0d2c825").loc("Polsk") + " (PL)",
      shortLabel: "pl",
    },
    de: {
      callingCode: 49,
      cvpLocale: CvpLocale.de,
      localeNameNorwegian: "Tysk",
      label: L.id("63bf2305626d").loc("Tysk") + " (DE)",
      shortLabel: "de",
    },
  };
};

export const useLocaleList = () => {
  const locales = useLocales();

  return Object.values(locales).map((locale) => ({
    label: locale.label,
    value: locale.cvpLocale,
  }));
};

export function getCallingCode(cvpLocale: CvpLocale) {
  if (cvpLocale === CvpLocale.nb) return 47;
  if (cvpLocale === CvpLocale.en) return 44;
  if (cvpLocale === CvpLocale.da) return 45;
  if (cvpLocale === CvpLocale.sv) return 46;
  if (cvpLocale === CvpLocale.pl) return 48;
  if (cvpLocale === CvpLocale.de) return 49;
  if (cvpLocale === CvpLocale.fr) return 33;

  throw new Error("Invalid locale: " + cvpLocale);
}
